import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// Define a service using a base URL and expected endpoints
export const travelInsightApi = baseApi.injectEndpoints({
  reducerPath: "travelInsightApi",
  endpoints: (builder) => ({
    addTravelInsight: builder.mutation({
      query: (user) => {
        return {
          url: "travel-insight",
          method: "POST",
          body: user,
          headers: {
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["travel"],
    }),
    updateTravelInsight: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `travel-insight/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["travel"],
    }),
    deleteTravelInsight: builder.mutation({
      query: (id) => {
        return {
          url: `travel-insight/${id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["travel"],
    }),
    getAllTravelInsight: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `travel-insight?${queryParams}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          //   authorization: `Bearer ${getToken()}`,
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["travel"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddTravelInsightMutation,
  useUpdateTravelInsightMutation,
  useDeleteTravelInsightMutation,
  useGetAllTravelInsightQuery, // Add this line to import the query hook
} = travelInsightApi;
